export const MAPBOX_DARK =
  'https://api.mapbox.com/styles/v1/mapbox/dark-v9/tiles/256/{z}/{x}/{y}?access_token=' +
  import.meta.env.VITE_MAPBOX_TOKEN;
